import { ReactElement } from 'react';
import { getMediaUrl, MediaUrls } from '../../utils';

export default function JohnsonHealthTech(): ReactElement {
  return (
    <div style={{ textAlign: 'left' }}>
      <a
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
        target={'_blank'}
        href={'https://www.johnsonfitness.com/'}
        rel="noreferrer"
      >
        <div style={{ flex: 1, alignContent: 'left' }}>
          <img
            src={getMediaUrl(MediaUrls.JohnsonHealthTechLogo)}
            style={{ objectFit: 'contain', width: '5rem' }}
            alt="Johnson Health Tech Logo"
          ></img>
        </div>
      </a>
      <div style={{ textAlign: 'center', fontSize: 20 }}>
        Johnson Health Tech
      </div>
      <hr></hr>
      <p>
        <i>
          A fitness and wellness equipment company that designs, manufactures,
          and sells products globally.
        </i>
        <br />* Web Developer III, August 2023 - Present
      </p>
      <div>
        <b>{'Programming languages: '}</b>
        <div style={{ paddingLeft: '0.5rem' }}>
          Primary: Typescript and JavaScript
        </div>
        <b>{'Programming environment: '}</b>
        <div style={{ paddingLeft: '0.5rem' }}>
          Primary: AWS, React, and MongoDB
          <br />
          Secondary: NestJS
        </div>
        <br />
        <p>
          At Johnson Health Tech, Jason has led projects that streamline
          operations and reduce costs, including spearheading major AI
          initiatives.
          <br />
          <br />
          He volunteered as the sole developer on a project using LLMs and AWS
          Bedrock to generate AI-driven workout plans. Jason took the project
          from a base Python model to production, converting it to Node.js to
          align with the team’s stack. He designed infrastructure for
          long-running tasks, implemented a polling-based user experience, built
          features for workout tracking, continuation, and scheduling, and
          optimized prompting and queuing, reducing runtime from 10 minutes to 2
          minutes.
          <br />
          Jason also led the migration of a critical service from Elastic
          Beanstalk to AWS Lambda, simplifying the architecture and achieving
          significant cost savings without disrupting traffic. By identifying
          unused resources, he further reduced expenses by $20,000 per month.
          <br />
          He managed integrations with third-party vendors, upgraded the
          codebase to TypeScript for maintainability, overhauled the testing
          framework, and contributed to a vendor-facing React application with
          styles, loading logic, and custom integrations.
          <br />
          Beyond technical work, Jason delivered leadership presentations
          highlighting his team’s accomplishments and solutions.
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 10,
          }}
        >
          <div
            style={{
              border: '1px solid grey',
              padding: 10,
            }}
          >
            <b>Skills gained</b>
            <ul>
              <li>AWS</li>
              <li>Cost optimization</li>
              <li>Machine Learning</li>
              <li>Systems Architecture</li>
              <li>TypeScript</li>
              <li>Vendor integrations</li>
              <li>Leadership presentations</li>
              <li>React</li>
              <li>Mocha Testing frameworks</li>
              <li>Docker</li>
              <li>DynamoDB</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
